module.exports = __webpack_public_path__ + "static/media/header-hero.0425d08a.jpeg";